module.exports = __webpack_public_path__ + "static/media/11.56c6e77f.webp";